import React, { useState } from 'react';
import { ArrowRight, ArrowLeft, X } from 'lucide-react';

const BeforeAfterGallery = ({ beforeAfterPairs, title = "Our Work" }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showBefore, setShowBefore] = useState(true);

  const openLightbox = (index) => {
    setSelectedIndex(index);
    setShowBefore(true);
  };

  const closeLightbox = () => {
    setSelectedIndex(null);
  };

  const nextImage = () => {
    setSelectedIndex((prev) => (prev + 1) % beforeAfterPairs.length);
    setShowBefore(true);
  };

  const prevImage = () => {
    setSelectedIndex((prev) => (prev - 1 + beforeAfterPairs.length) % beforeAfterPairs.length);
    setShowBefore(true);
  };

  return (
    <div>
      <h2 className="text-3xl md:text-4xl font-heading font-bold text-dark-navy mb-8 text-center">
        {title}
      </h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {beforeAfterPairs.map((pair, index) => (
          <div
            key={index}
            className="relative group cursor-pointer overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all duration-300"
            onClick={() => openLightbox(index)}
          >
            <div className="relative aspect-[4/3]">
              {/* Before image - always visible */}
              <img
                src={pair.before}
                alt={`Before ${index + 1}`}
                className="absolute inset-0 w-full h-full object-cover opacity-100 group-hover:opacity-0 transition-opacity duration-500"
              />
              {/* After image - shown on hover */}
              <img
                src={pair.after}
                alt={`After ${index + 1}`}
                className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500"
              />
            </div>
            
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4">
              <div className="flex justify-between items-center text-white text-sm font-semibold">
                <span>Before</span>
                <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform" />
                <span>After</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedIndex !== null && (
        <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4">
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white hover:text-bmw-blue transition p-2"
          >
            <X size={32} />
          </button>

          <button
            onClick={prevImage}
            className="absolute left-4 text-white hover:text-bmw-blue transition p-2"
          >
            <ArrowLeft size={32} />
          </button>

          <button
            onClick={nextImage}
            className="absolute right-4 text-white hover:text-bmw-blue transition p-2"
          >
            <ArrowRight size={32} />
          </button>

          <div className="max-w-6xl w-full">
            <div className="relative aspect-[4/3] bg-dark-navy rounded-lg overflow-hidden">
              <img
                src={showBefore ? beforeAfterPairs[selectedIndex].before : beforeAfterPairs[selectedIndex].after}
                alt={showBefore ? 'Before' : 'After'}
                className="w-full h-full object-contain"
              />
            </div>

            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => setShowBefore(true)}
                className={`px-8 py-3 rounded-lg font-semibold transition ${
                  showBefore
                    ? 'bg-bmw-blue text-white'
                    : 'bg-white text-dark-navy hover:bg-soft-grey'
                }`}
              >
                Before
              </button>
              <button
                onClick={() => setShowBefore(false)}
                className={`px-8 py-3 rounded-lg font-semibold transition ${
                  !showBefore
                    ? 'bg-bmw-blue text-white'
                    : 'bg-white text-dark-navy hover:bg-soft-grey'
                }`}
              >
                After
              </button>
            </div>

            <p className="text-white text-center mt-4 text-sm">
              {selectedIndex + 1} / {beforeAfterPairs.length}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BeforeAfterGallery;
